import React from "react";
import getDisplayName from "authentication/helpers/getDisplayName";
import { FormikFormGroup } from "components/common";
const OidcBaseUrlField = ({ help, type, isOkta, disabled, validate }) => {
  const label = `${getDisplayName(type)} base URL`;
  const name = isOkta ? "oktaBaseUrl" : "baseUrl";
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      help,
      label,
      name,
      disabled,
      validate,
      placeholder: label
    }
  ));
};
export default OidcBaseUrlField;
